import { Rule } from 'antd/lib/form'

import { ProjectHoursBudgetCaptureBlock as ProjectHoursBudgetCaptureBlockType } from '../../types/blueprint'

import { CaptureBlockFormItem } from './CaptureBlockFormItem'

import { InputNumber } from '@/components/shared-components/BUI/Input'

type Props = {
  block: ProjectHoursBudgetCaptureBlockType
  rules: Rule[]
}

export const ProjectHoursBudgetCaptureBlock: React.FC<Props> = ({
  block,
  rules,
}) => {
  const { value } = block

  return (
    <CaptureBlockFormItem
      label={'Project completion % as of EOD'}
      initialValue={value}
      normalize={(value) => (value ? Number(value) : undefined)}
      rules={[...rules, { type: 'integer', min: 0, max: 100 }]}
      block={{
        ...block,
        description:
          'If this exceeds or is close to exceeding the budgeted hours used please speak to management immediately.',
      }}
    >
      <InputNumber precision={0} />
    </CaptureBlockFormItem>
  )
}
